import { AfterViewChecked, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatLegacyTabChangeEvent as MatTabChangeEvent, MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { CustomerSearch } from 'projects/zbs-app/src/app/services/Ebootis.Queries/CustomerSearch';
import { CustomerEditComponent } from '../customer-edit/customer-edit.component';

@Component({
	selector: 'app-customer',
	templateUrl: './customer.component.html',
	styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements AfterViewChecked {

	@Input() set forCompany(p_forCompany: boolean) {
		this.m_forCompany = p_forCompany;
	}

	get forCompany(): boolean {
		return this.m_forCompany;
	}

	@Input() set selectionMode(value: string) {
		this.m_selectionMode = value;
	}

	get selectionMode(): string {
		return this.m_selectionMode;
	}

	@Output() public customersSelected: EventEmitter<CustomerSearch.Customer | CustomerSearch.Customer[]> = new EventEmitter();

	@ViewChild(MatTabGroup, { static: true }) private matTabGroup: MatTabGroup;
	@ViewChild(CustomerEditComponent, { static: true }) private customerEditComponent: CustomerEditComponent;

	private m_forCompany: boolean = false;
	private m_selectionMode: string;
	public m_selectedCustomer: string = '';
	public m_selectedTab: number = 0;
	public m_savedCustomer: boolean = false;

	constructor() { }

	/**
	 * Die InkBar in der TabBar wird neu positioniert.
	 */
	public ngAfterViewChecked() {
		this.matTabGroup.realignInkBar();
	}

	/**
	 * Ein Kunde wurde gespeichert. Es wird die Methode exitCustomerEdit aufgerufen.
	 */
	public customerSaved(): void {
		this.m_savedCustomer = true;
		this.exitCustomerEdit(true);
	}

	/**
	 * Setzt den ausgewählten Customer zurück und wechselt den aktiven Tab.
	 * @param p_exit Boolean true wenn CustomerEdit geschlossen wurde.
	 */
	public exitCustomerEdit(p_exit: boolean): void {
		this.m_selectedCustomer = '';
		this.m_selectedTab = +(!p_exit);
	}

	/**
	 * Wenn in den ersten Tab gewechselt wird, wird die CustomerEdit FormGroup überprüft.
	 * @param p_event ChangeEvent wenn ein Tab gewechselt wurde
	 */
	public tabChanged(p_event: MatTabChangeEvent): void {
		if (p_event.index == 0) {
			this.customerEditComponent.checkCustomerForm();
		}
	}

	/**
	 * Übergibt einen Customer an das aufrufende Component.
	 * @param p_customers Ausgewählter Customer aus der CustomerSearch
	 */
	public selectedCustomers(p_customers: CustomerSearch.Customer | CustomerSearch.Customer[]): void {
		this.customersSelected.emit(p_customers);
	}

	/**
	 * Es wird in CustomerEdit gewechselt. Der Tab wird gesetzt.
	 * @param p_customer OID des Customers
	 */
	public editCustomer(p_customer: string): void {
		this.m_selectedCustomer = p_customer;
		this.m_selectedTab = 1;
		this.m_savedCustomer = false;
	}
}
